import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

/** Vite の BASE_URL（例: /cadec2026/）を React Router の basename に変換（末尾スラッシュなし） */
function routerBasename(): string {
  const b = import.meta.env.BASE_URL.replace(/\/$/, "") || "/";
  return b;
}

/**
 * BrowserRouter: 例 https://example.com/cadec2026/contact のようなパス型 URL。
 * 再読み込み時はサーバーが index.html にフォールバックする必要あり（public/.htaccess を同梱）。
 */
function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={routerBasename()}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
